import { render, staticRenderFns } from "./ForbiddenAccessModal.vue?vue&type=template&id=2a6254b3"
import script from "./ForbiddenAccessModal.vue?vue&type=script&lang=js"
export * from "./ForbiddenAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports